import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.5 18 10 6h3.5L8 18Z" }, null, -1),
    _createElementVNode("path", {
      fill: "#008bbf",
      "fill-opacity": ".35",
      stroke: "#008bbf",
      d: "m11 18 5.5-12H20l-5.5 12Z",
      class: "model-icon-accent"
    }, null, -1)
  ]))]))
}
export default { render: render }